import styled from 'styled-components'
import { Text } from '../components/style'

export const Wrap = styled("div")`
  ${Text} {
    font-size: 18px;
  }
  padding-bottom: 50px;
`;
